export const CHURN_RISK_LABELS = {
    baixo: "Baixo",
    medio: "Médio",
    alto: "Alto",
    critico: "Crítico",
};

export const CHURN_RISK_COLORS = {
    baixo: "success",
    medio: "accent",
    alto: "warning",
    critico: "danger",
};

export const RISK_FILTER_OPTIONS = [
    { label: "Todos os Níveis", value: "all" },
    { label: "Risco Baixo", value: "baixo" },
    { label: "Risco Médio", value: "medio" },
    { label: "Risco Alto", value: "alto" },
    { label: "Risco Crítico", value: "critico" },
];
